import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-pinpad',
  templateUrl: './pinpad.component.html',
  styleUrls: ['./pinpad.component.scss'],
})
export class PinpadComponent implements OnInit {
  @Input() modo: string;
  @Input() trab: string;

  titulo: string;
  subtitulo: string;
  pin = '';

  constructor(
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {
    switch (this.modo) {
      case 'change': {
        this.titulo = 'CAMBIAR PIN';
        this.subtitulo = 'INTRODUCE PIN ACTUAL'
        break
      }
      case 'crear1': {
        this.titulo = 'NUEVO PIN';
        this.subtitulo = 'INTRODUCE NUEVO PIN'
        break
      }
      case 'crear2': {
        this.titulo = 'NUEVO PIN';
        this.subtitulo = 'REINTRODUCE EL PIN'
        break
      }
      default: {
        this.titulo = 'FICHAR ENTRADA/SALIDA';
        this.subtitulo = 'INTRODUCE EL PIN'
      }
    }
  }

  handleInput = async (opt: string) => {
    if (opt === 'cancel') {
      await this.modalCtrl.dismiss(null);
      return
    }
    if (opt === 'change') {
      await this.modalCtrl.dismiss('change');
      return
    }
    this.pin += opt;
    if (this.pin.length === 4) {
      await this.modalCtrl.dismiss(this.pin);
    }
  }

  icon = (n: number) => this.pin.length < n ? 'radio-button-off' : 'radio-button-on';
}
